import { render, staticRenderFns } from "./FormGroupComponent.vue?vue&type=template&id=6fd880b7&scoped=true&"
import script from "./FormGroupComponent.vue?vue&type=script&lang=js&"
export * from "./FormGroupComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormGroupComponent.vue?vue&type=style&index=0&id=6fd880b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd880b7",
  null
  
)

export default component.exports